/**
 * 账户API配置
 * {
 *   name: 调用接口的别名
 *   url：api
 *   method：get | post | put | delete
 * }
 */
export default {
  login: {
    name: "login",
    url: "/ams/assignor/doLogin",
    method: "post"
  },
  logout: {
    name: "logout",
    url: "/ams/assignor/logout",
    method: "get"
  },
  register: {
    name: "register",
    url: "/ams/assignor/register",
    method: "post"
  },
  protocol: {
    name: "protocol",
    url: "/ams/operating/serviceProtocal",
    method: "get"
  },
  token: {
    name: "token",
    url: "/ams/assignor/tokenStatus",
    method: "post"
  }
};
